module.exports = __webpack_public_path__ + "static/media/housinghero.c05311ef.png";